<template>
  <div>
    <h1>Einträge</h1>
    <h2 v-if="selectedItem && selectedItem.id > 0">Bearbeiten</h2>
    <h2 v-else-if="selectedItem && selectedItem.id == 0">Neu</h2>
    <button v-if="!selectedItem && !imgEditItem" @click="addItem">Neu</button>

    <LoadingSpinner v-if="isLoading"></LoadingSpinner>
    <template v-else>
      <template v-if="!selectedItem && !imgEditItem">
        <table v-if="items && items.length > 0" style="max-width: 100%;">
          <tr>
            <th>Titel</th>
            <th>Datum</th>
            <th>Keine Details?</th>
            <th>Kategorien</th>
            <th>Aktionen</th>
          </tr>
          <tr v-for="item in items">
            <td>
              {{ item.title }}
            </td>
            <td>
              {{ item.date | toDateString }}
            </td>
            <td>
              <template v-if="item.noDetails">
                Ja
              </template>
              <template v-else>
                Nein
              </template>
            </td>
            <td>
              <template v-for="(category, index) in item.categories">
                {{ category.name }}<template v-if="index + 1 < item.categories.length">, </template>
              </template>
            </td>
            <td>
              <button @click="deleteItem(item)">Löschen</button>
              <button @click="selectedItem = item">Bearbeiten</button>
              <button @click="imgEditItem = item">Bilder</button>
            </td>
          </tr>
        </table>
        <template v-else>
          Keine Daten gefunden
        </template>
      </template>
      <template v-else-if="!imgEditItem">
        <div class="edit-form">
          <label>Titel</label>
          <input type="text" v-model="selectedItem.title" maxlength="255" />
          <br />
          <label>Datum</label>
          <input type="text" v-model="selectedItem.date" maxlength="255" />
          <br />
          <label>
            Text<br />
            <span class="note">
              <a href="https://de.wikipedia.org/wiki/Markdown" target="_blank">(Markdown-Syntax)</a>
            </span>
          </label>
          <textarea v-model="selectedItem.text" />
          <br />
          <label for="noDetails">
            Keine Details?
          </label>
          <input id="noDetails" type="checkbox" v-model="selectedItem.noDetails" />
          <br />
          <label>
            Kategorien
          </label>
          <div v-if="categories" style="float: left;">
            <div v-for="cat in categories"
                 :style="`border-color: ${cat.color}`"
                 :class="{ category: true, 'category-selected': cat.selected }"
                 @click="cat.selected = !cat.selected">
              {{ cat.name }}
            </div>
          </div>
        </div>

        <button @click="saveItem">Speichern</button>
        <button @click="selectedItem = null">Abbrechen</button>
      </template>
      <template v-else>
        <h2>Bilder: {{ imgEditItem.title }}</h2>

        Hinzufügen:
        <input ref="uploadFiles" type="file" name="uploadFiles" id="uploadFiles" accept="image/*" multiple />
        <button @click="startImageUpload">Hochladen</button>
        <button @click="imgEditItem = null">Zurück zu den Einträgen</button>
        <button @click="saveImageSorting">Bild-Zuordnung und -Sortierung speichern</button>

        <div class="images">
          <div class="image-container">
            Groß
            <div class="image-list">
              <draggable v-model="largeImages"
                         :options="{ group: 'images' }"
                         @start="drag = true"
                         @end="drag = false"
                         class="dragArea">
                <div class="image" v-for="img in largeImages">
                  <img :src="img.url" style="max-width: 120px; max-height: 120px;" />
                  <div style="float: right;">
                    <a @click="removeImage(img)">Löschen</a>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="image-container">
            Mittel
            <div class="image-list">
              <draggable v-model="mediumImages"
                         :options="{ group: 'images' }"
                         @start="drag = true"
                         @end="drag = false"
                         class="dragArea">
                <div class="image" v-for="img in mediumImages">
                  <img :src="img.url" style="max-width: 120px; max-height: 120px;" />
                  <div style="float: right;">
                    <a @click="removeImage(img)">Löschen</a>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="image-container">
            Klein
            <div class="image-list">
              <draggable v-model="smallImages"
                         :options="{ group: 'images' }"
                         @start="drag = true"
                         @end="drag = false"
                         class="dragArea">
                <div class="image" v-for="img in smallImages">
                  <img :src="img.url" style="max-width: 120px; max-height: 120px;" />
                  <div style="float: right;">
                    <a @click="removeImage(img)">Löschen</a>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import LoadingSpinner from '../../parts/LoadingSpinner'
  import rest from '../../../services/rest'
  import Vue from 'vue'
  import draggable from 'vuedraggable'

  export default {
    name: 'AdminEntries',
    components: {
      LoadingSpinner,
      draggable
    },
    data () {
      return {
        isLoadingItems: true,
        items: [],
        selectedItem: null,
        isLoadingCategories: true,
        categories: [],
        selectedCategories: [],
        imgEditItem: null,
        smallImages: [],
        mediumImages: [],
        largeImages: []
      }
    },
    computed: {
      isLoading () {
        return this.isLoadingItems || this.isLoadingCategories
      }
    },
    watch: {
      selectedItem () {
        let item = this.selectedItem
        this.categories.forEach((cat) => {
          if (item) {
            let foundCategory = item.categories.find((c) => {
              return c.id === cat.id
            })
            let isSelected = (item.id > 0) && foundCategory
            cat.selected = isSelected
          } else {
            cat.selected = false
          }
        })
      },
      imgEditItem () {
        if (!this.imgEditItem || !this.imgEditItem.images) {
          this.smallImages = []
          this.mediumImages = []
          this.largeImages = []
          return
        }
        this.smallImages = this.imgEditItem.images.filter((img) => { return img.size === null || img.size === 0 })
        this.smallImages = this.smallImages.sort((a, b) => { return a.sortOrder - b.sortOrder })
        this.mediumImages = this.imgEditItem.images.filter((img) => { return img.size === 1 })
        this.mediumImages = this.mediumImages.sort((a, b) => { return a.sortOrder - b.sortOrder })
        this.largeImages = this.imgEditItem.images.filter((img) => { return img.size === 2 })
        this.largeImages = this.largeImages.sort((a, b) => { return a.sortOrder - b.sortOrder })
      }
    },
    methods: {
      loadItems () {
        this.isLoadingItems = true
        rest.entries.all((response, hasError) => {
          if (hasError) { return }
          this.items = response.body
          this.isLoadingItems = false
        })
      },
      loadCategories () {
        this.isLoadingCategories = true
        rest.categories.all((response, hasError) => {
          if (hasError) { return }
          let categories = response.body
          categories.forEach((cat) => {
            cat.selected = false
          })
          this.categories = categories
          this.isLoadingCategories = false
        })
      },
      deleteItem (item) {
        if (!confirm('Wollen Sie das wirklich löschen?')) { return }
        this.isLoadingItems = true
        rest.entries.delete(item.id, (response, hasError) => {
          if (!hasError) {
            let index = this.items.indexOf(item)
            if (index > -1) {
              this.items.splice(index, 1)
            }
          }
          this.isLoadingItems = false
        })
      },
      addItem () {
        let newItem = {
          id: 0,
          title: '',
          text: '',
          categories: [],
          noDetails: false,
          date: new Date().getFullYear() + '-01-01'
        }
        this.selectedItem = newItem
      },
      saveItem () {
        this.isLoadingItems = true
        // set categories
        this.selectedItem.categories = []
        this.categories.forEach((cat) => {
          if (cat.selected) {
            this.selectedItem.categories.push(cat)
          }
        })

        if (this.selectedItem.id > 0) {
          // Update
          rest.entries.update(this.selectedItem, (response, hasError) => {
            if (hasError) {
              this.isLoadingItems = false
              return
            }
            let newItem = response.body
            let index = this.items.indexOf(this.selectedItem)
            Vue.set(this.items, index, newItem)
            this.selectedItem = null
            this.isLoadingItems = false
          })
        } else {
          // Insert
          rest.entries.add(this.selectedItem, (response, hasError) => {
            if (hasError) {
              this.isLoadingItems = false
              return
            }
            let newItem = response.body
            this.items.push(newItem)
            this.selectedItem = null
            this.isLoadingItems = false
          })
        }
      },
      startImageUpload () {
        let files = this.$refs.uploadFiles.files
        if (!files || files.length < 1) {
          return
        }
        rest.entries.addImage(this.imgEditItem.id, files, (response, hasError) => {
          if (hasError) {
            return
          }
          let newItem = response.body
          let index = this.items.indexOf(this.imgEditItem)
          Vue.set(this.items, index, newItem)
          this.imgEditItem = newItem
        })
      },
      removeImage (img) {
        rest.entries.removeImage(img.id, (response, hasError) => {
          if (hasError) {
            return
          }
          let newItem = response.body
          let index = this.items.indexOf(this.imgEditItem)
          Vue.set(this.items, index, newItem)
          this.imgEditItem = newItem
        })
      },
      saveImageSorting () {
        rest.entries.saveImageMapping(this.smallImages, this.mediumImages, this.largeImages, (response, hasError) => {})
        let sortIndex = 0
        this.smallImages.forEach((img) => {
          img.size = 0
          img.sortOrder = sortIndex
          sortIndex++
        })
        sortIndex = 0
        this.mediumImages.forEach((img) => {
          img.size = 1
          img.sortOrder = sortIndex
          sortIndex++
        })
        this.largeImages.forEach((img) => {
          img.size = 2
          img.sortOrder = sortIndex
          sortIndex++
        })
      }
    },
    mounted () {
      this.loadItems()
      this.loadCategories()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .category {
    border: 1px solid white;
    color: white;
    border-radius: 10px;
    width: 500px;
    text-align: center;
    margin: 10px 0;
    cursor: pointer;
  }
  .category-selected {
    background-color: lightgray;
    color: black;
  }
  .image-container {
    float: left;
    width: 350px;
  }
  .image {
    width: 300px;
    border: 1px solid darkslategray;
    background-color: white;
    color: black;
    padding: 3px;
    cursor: move;
  }
  .dragArea {
    min-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// AdminEntries.vue?2022d58c